/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { trashedPlanDirectLinkRoute } from '@jira/router-routes__advanced-roadmaps-spa-routes/src/trashedPlanDirectLinkRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	TrashedPlanDirectLink,
	LazyTrashedPlanDirectLink,
} from './ui/trashed-plan-direct-link/index.tsx';

export const trashedPlanDirectLinkRouteEntry: Route = createEntry(
	trashedPlanDirectLinkRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: TrashedPlanDirectLink,
		layout: globalLayout,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyTrashedPlanDirectLink],
		ufoName: 'plan-trashed',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
